module.exports = __webpack_public_path__ + "assets/img/line3.509241a9.png";